import { useStorage } from '@/js/libs/hooks/useStorage';

export enum StorageScope {
  GENERAL = 'adnz',
  CREATIVES = `${StorageScope.GENERAL}_adserver_creatives_page`,
  POST_BOOKING_TOOL = `${StorageScope.GENERAL}_post_booking_tool`,
}

export enum StorageKey {
  PUZZLE_NAV_COLLAPSED = 'puzzle_nav_collapsed',
  COMPANY = 'selected_company',
  FILTERS = 'filters',
  HIDDEN_COLUMNS_DOOH = 'hidden_columns_dooh',
  HIDDEN_COLUMNS_UNADDRESSED = 'hidden_columns_unaddressed',
  DEFAULT_COMPANY = 'default',
  PUBLISHERS_WEBSITE = 'publishers_website',
  TOGGLED_VISUALIZATIONS = 'toggled_visualizations',
  VERIFICATION_EMAIL = 'verification_email',
  FORCED_LOGOUT_COMPLETED = 'forced_logout_complete',
  THEME_ID = 'themeId',
  TRANSLATE_MODE_ENABLED = 'translate_mode_enabled',
  TEMPORARY_ACCESS_EXPIRES_AT = 'temporary_access_expires_at',
}

const useLocalStorage = (scope = StorageScope.GENERAL) => useStorage<StorageKey, StorageScope>({ scope, storage: window.localStorage });

export default useLocalStorage;
